import { Box } from '@mui/material';
import { studentProgressStyles } from './StudentProgress.styles';
import { formatDateTimeUS } from '../../../services/Utilities';
import RunnerIcon from './Images/ex-runner.svg';

export interface StudentProgressProps {
  progressPercentage: number;
  startDate: Date;
  endDate: Date;
  isEndedExperience?: boolean;
  isScheduledExperience?: boolean;
}

export const StudentProgress = ({
  progressPercentage,
  startDate,
  endDate,
  isEndedExperience = false,
  isScheduledExperience = false,
}: StudentProgressProps) => {
  const normalizedProgress = Math.min(100, Math.max(0, progressPercentage));
  const dateRange = `${formatDateTimeUS(startDate)} - ${formatDateTimeUS(endDate)}`;

  if (isScheduledExperience) {
    return (
      <Box sx={studentProgressStyles.container}>
        <Box sx={studentProgressStyles.scheduledDates}>
          Scheduled to start at {dateRange}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={studentProgressStyles.container}>
      <Box
        role="progressbar"
        aria-label="Student progress"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={normalizedProgress}
        sx={studentProgressStyles.progressBarTrack}
      >
        <Box sx={studentProgressStyles.progressBarFill(normalizedProgress, isEndedExperience)} />
        <Box
          component="span"
          role="img"
          aria-label="Running progress indicator"
          sx={studentProgressStyles.runningManIcon(normalizedProgress, RunnerIcon)}
        />
        <Box sx={studentProgressStyles.dateRange(isEndedExperience, normalizedProgress)}>
          {dateRange}
        </Box>
      </Box>
    </Box>
  );
};

export default StudentProgress;
